import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import useTheme from "@mui/material/styles/useTheme";

import { error } from "app/themes/colors";
import { extractBackendErrorStringMessages } from "utils/common";
import { viteEnv } from "utils/vite-env.util";

type ErrorSnackbarContentProps = {
  response: any;
  title?: string;
  filterMessages?: (messages: string[]) => string[];
  includeFieldName?: boolean;
};

const shouldHideErrors = () =>
  viteEnv.VITE_ENV === "prod" || viteEnv.VITE_ENV === "preprod";

export default function ErrorSnackbarContent({
  title = "The action was unsuccessful due to these errors:",
  response,
  filterMessages,
  includeFieldName = false
}: ErrorSnackbarContentProps) {
  const theme = useTheme();
  let showGenericTextOnly = shouldHideErrors();
  let messages = new Set<string>();
  extractBackendErrorStringMessages(response, messages, includeFieldName);
  if (filterMessages) {
    messages = new Set(filterMessages([...messages]));
    showGenericTextOnly = false;
  }

  const showGenericText = showGenericTextOnly || messages.size === 0;
  const genericText = "An Error has Occurred, please reach out to support.";
  const headerText =
    showGenericText && messages.size > 0
      ? `${genericText} (${[...messages].join(" ")})`
      : showGenericText
        ? genericText
        : title;
  return (
    <Stack spacing={1} zIndex={theme.zIndex.snackbar}>
      <Typography fontWeight={700} color={error[700]}>
        {headerText}
      </Typography>
      {!showGenericTextOnly && (
        <Typography component="ul">
          {[...messages].map((message) => (
            <Typography component="li" key={message} color={error[700]}>
              {message}
            </Typography>
          ))}
        </Typography>
      )}
    </Stack>
  );
}
